// Avoid `console` errors in browsers that lack a console ---------------------------------------------------
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

// Global Scope Vars ----------------------------------------------------------------------------------------
var $ = jQuery,
    siteurl = MYSCRIPT.siteurl,
    ajaxurl = MYSCRIPT.ajaxurl,
    body = $('body'),
    winHieght = $(window).height(),
    winWidth = $(window).width(),
    headerHieght = $('#header').outerHeight(),
    scroll_distance;

// console.log( 'Site URL: ' + MYSCRIPT.siteurl );
// console.log( 'AJAX URL: ' + MYSCRIPT.ajaxurl );
// console.log('Site URL: ' + siteUrl);

// Add Plugins here ----------------------------------------------------------------------------------------
import Cookies from "js-cookie";
import "jquery-match-height/dist/jquery.matchHeight";

// Theme functions -----------------------------------------------------------------------------------------

function scrollToEl(el, speed, offset){
    $('html, body').animate({
        scrollTop: (el.offset().top) + offset
    }, speed);
}

// Update Header functions
function updateHeader() {
    scroll_distance = $(document).scrollTop();
    if(scroll_distance > 500){
        body.addClass('nav-mini');
        $("#toTop").fadeIn("slow");
    } else {
        body.removeClass('nav-mini');
        $("#toTop").fadeOut("fast");
    }
}

// Set Vars
function setVar() {
    document.querySelector(':root').style
        .setProperty('--vh', window.innerHeight/100 + 'px');

    document.querySelector(':root').style
        .setProperty('--wpAdminBarHeight', ($('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0) + 'px');

    // var header_wrapper_height = header_wrapper.length ? header_wrapper.outerHeight() : 0;
    // document.querySelector(':root').style
    //     .setProperty('--headerHeight', header_wrapper_height + 'px');
}

// Mega Menu
function mega_menu() {
    if ( winWidth < 992 ) {

        $('.mega-menu-wrapper').remove();

        $('.hamburger-toggle').on( "click", function() {
            $('.hamburger-toggle .hamburger').toggleClass( "active" );
            $(this).closest('.navbar-collapse').slideToggle();
            $('.dropdown-menu').slideUp();
            $("#navbar-content").toggleClass('shadow');
            //console.log('Hamburger Menu Clicked');
            
        });

        $('.dropdown-toggle').on( "click", function() {
            $(this).closest('.dropdown-mega').find('.dropdown-menu').slideToggle();
            //console.log('Mobile Dropdown Toggle Clicked');
        });

    } else if ( ( winWidth > 991 ) && ( window.matchMedia("(pointer: coarse)").matches ) ) {

        //$('.dropdown-menu').remove();

        $('.dropdown-toggle').on( "click", function() {
            var mNav = $(this).data("mega-menu");
            $('.mega-menu-wrapper').not('#' + mNav).slideUp(150);
            $(body).find('#' + mNav).toggleClass('mega-open');
        });

        var timer;

        $(".mega-menu-wrapper, .navbar-nav").mouseleave(function() {
            timer = setTimeout(closeMega, 10);
        }).mouseenter(function() {
            clearTimeout(timer);
        });

        function closeMega() {
            $('.mega-menu-wrapper').removeClass('mega-open');
            $('.nav-link').removeClass('activeM');
        }

    } else {

        //$('.dropdown-menu').remove();

        $('.mega-menu-wrapper').mouseover(function() {
            $(this).addClass('mega-open');
            var menuItem = $(this).attr("data-mm");
            $(body).find('.' + menuItem).addClass('activeM');
        });

        $('.nav-link').mouseover(function() {
            if ($(this).is('.dropM')) {
                var mNav = $(this).parent().find('.dropdown-toggle').data("mega-menu");
                $(this).addClass('activeM');
                setTimeout(function(){
                    $('.mega-menu-wrapper').removeClass('mega-open');
                    $('#' + mNav).addClass('mega-open');
                    //$('#' + mNav).slideDown(150);

                }, 200);

            } else {
                $('.nav-link').removeClass('activeM');
                $('.mega-menu-wrapper').removeClass('mega-open');
                //$('.mega-menu-wrapper').slideUp(150);

            }
        });

        var timer;

        $(".mega-menu-wrapper, .navbar-nav").mouseleave(function() {
            timer = setTimeout(closeMega, 10);
        }).mouseenter(function() {
            clearTimeout(timer);
        });

        function closeMega() {
            $('.mega-menu-wrapper').removeClass('mega-open');
            $('.nav-link').removeClass('activeM');
        }

    }
}

function cat_image_padding() {
    if ( $( "body.archive" ).length ) {
        setTimeout(function(){
            var catImgHeight = $('.cat-wrap > img').outerHeight();
            catImgHeight = (catImgHeight/1.5);
            $('.cat-banner').css('padding-bottom', catImgHeight);
            $('.pullup').css('margin-top', -Math.abs(catImgHeight) );
        }, 200);
    }
}

// Add target _blank to external links & PDF's.
function add_target_blank_to_external_links_and_pdfs() {
    $('a[href$=".pdf"]').addClass('download').attr('target', '_blank');
    $('a[href^="http://"], a[href^="https://"]').not('a[href*="'+location.hostname+'"]').attr('target','_blank');
}

// adjust text position/width in slider to overlay shadow
// function slider_text_position() {
//     if ( $( ".product-slider" ).length ) {
//         setTimeout(function(){
//             $( ".product-slide-wrap > .text-wrap" ).each(function( index ) {
//                 var imgWidth = $(this).closest('.product-slide-wrap').find('.product-image').width();
//                 //console.log(imgWidth);
//                 var padding= '';
//                 if ( winWidth >= 1920 ) {
//                     padding = (imgWidth - 80);
//                     //console.log('1920 padding-left: ' + padding);
//                 } else if ( winWidth >= 1366 ) {
//                     padding = (imgWidth - 50);
//                     //console.log('1366 padding-left: ' + padding);
//                 } else if ( winWidth >= 1200 ) {
//                     padding = (imgWidth - 50);
//                     //console.log('1200 padding-left: ' + padding);
//                 } else if ( winWidth >= 1024 ) {
//                     padding = (imgWidth - 40);
//                     //console.log('1024 padding-left: ' + padding);
//                 } else if ( winWidth >= 768 ) {
//                     padding = (imgWidth - 30);
//                     //console.log('768 padding-left: ' + padding);
//                 } else {
//                     padding = 0;
//                     //console.log('NO PADDING');
//                 }
//                 $(this).css('padding-left', padding);
//                 //console.log( index + ": " + $( this ).text() );
//             });
//         }, 200);
//     }
// }

// adjust heights in Product section
function productHeights() {
    if ( $( ".products-module-2" ).length ) {
        if ( winWidth >= 768 ) {
            $('.products-module-2 .description').matchHeight();
            $('.products-module-2 h3').matchHeight();
            $('.products-module-2 .intro').matchHeight();
            //console.log('MH Done');
        } else {
            $('.item').matchHeight({ remove: true });
        }
    }
    if ( $( ".product-offers" ).length ) {
        if ( winWidth >= 768 ) {
            $('.product-offers .img-wrap').matchHeight();
            $('.product-offers h2').matchHeight();
        }
    }
}

// Destini negative margin top...
function destini_margins() {
    if ( $( ".product-finder" ).length ) {

        setTimeout(function(){

            var destinitHeight, h1BtmMargin, destiniTopMargin  = '';

            destinitHeight = $('#destini').outerHeight();

            console.log('Destini Product iFrame Height: ' + destinitHeight);

            if ( winWidth > 991 ) {
                //destinitHeight = 820;
                h1BtmMargin = (destinitHeight/3)+80;  
                destiniTopMargin = -Math.abs(destinitHeight/3)-48;

            } else if ( winWidth > 767 ) {
                //destinitHeight = 949;
                h1BtmMargin = (destinitHeight/4)+32;  
                destiniTopMargin = -Math.abs(destinitHeight/4);

            } else if ( winWidth > 575 ) {
                //destinitHeight = 1696;
                h1BtmMargin = (destinitHeight/5)+32;
                destiniTopMargin = -Math.abs(destinitHeight/5);

            } else {
                h1BtmMargin = '1rem';
                destiniTopMargin = 0;
            }

            $('.product-finder h1').css('margin-bottom', h1BtmMargin);
            $('#destiniwrap').css('margin-top', destiniTopMargin); 

        }, 200);

    }
}

// Countup on Promo Page Stats Module
// http://imakewebthings.com/waypoints/guides/getting-started/
// https://github.com/mhuggins/jquery-countTo
function count_up() {
    if ( $( "#stats" ).length ) {
        var waypoint = new Waypoint({
            element: document.getElementById('stats'),
            handler: function(down) {
                $('.big').countTo({
                    onComplete: function() {
                        $(this).countTo('stop');
                    }
                });
                this.destroy();
            }, 
            offset: '85%',
            triggerOnce: true
        })
    }
}

// Free Sample Button Click Cookie
// https://github.com/js-cookie/js-cookie/tree/latest#readme
function free_sample_cookie() {
    if ( $( '.free-sample-btn' ).length ) {
        $('.free-sample-btn').click(function() {
            var productID = $(this).attr('data-id');
            //console.log('Free Sample Button Clicked for ' + productID);
            Cookies.set('product_id', productID, { expires: 1 }, { secure: true })
        });
    }
}

// Make coupon consent field checked by default
function check_consent() {
    if ( $( "#input_2_8_1" ).length ) {
        $('#input_2_8_1').prop('checked', true);
    }
}
check_consent();

// Theme jQuery here ---------------------------------------------------------------------------------------
jQuery(document).ready(function($) {

    console.log( "Document ready" );

    "use strict";

    $('html').removeClass('no-js');
    $('html').addClass('js');

    setTimeout(function(){
        setVar();
    }, 200);

    // add data attribute to buy bow button in header
    $('#navbar-content a.main-btn').each(function () {
        if ($(this).text() == 'Buy Now') {
            $(this).attr('data-buy-now-id', '1');
        }
    });

    $('#navbar-content .nav-item a[href]').filter(function() {
        return this.href === window.location.href;
    }).addClass('active');

    // Magnific Popup 
    // https://dimsemenov.com/plugins/magnific-popup/documentation.html
    $('.video-link').magnificPopup({
        type:'iframe',
        mainClass: 'mfp-fade',
    });

    $('.posts > li a[href]').filter(function() {
        return this.href === window.location.href;
    }).addClass('active');

    destini_margins();

    //cat_image_padding();

    productHeights();

    count_up();

    check_consent();

    // https://kenwheeler.github.io/slick/
    if ( $( ".slides" ).length ) {
        setTimeout(function(){
            $('.slides').slick({
                mobileFirst: true,
                autoplay: true,
                autoplaySpeed: 7000,
                arrows: false,
                dots: true,
                fade: true,
                speed: 1000,
                cssEase: 'linear'
            });
        }, 200);
    }

    // https://kenwheeler.github.io/slick/
    if ( $( ".article-slider" ).length ) {
        setTimeout(function(){
            $('.article-slides').slick({
                mobileFirst: true,
                autoplay: true,
                infinite: false,
                autoplaySpeed: 3000,
                arrows: false,
                dots: true,
                speed: 1000,
                cssEase: 'linear',
                //respondTo: 'min',
                // centerMode: true,
                // variableWidth: true,
                rows: 0,
                responsive: [{

                    breakpoint: 1919,
                    settings: {
                      slidesToShow: 3,
                    }
              
                  },{
              
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 2,
                    }

                },{
              
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }

                },{
              
                    breakpoint: 320,
                    settings: {
                        slidesToShow: 1,
                    }

                }]
            }).on('setPosition', function (event, slick) {
                slick.$slides.css('height', slick.$slideTrack.height() + 'px');
            });
        }, 200);
    }

    // https://kenwheeler.github.io/slick/
    if ( $( ".product-slider" ).length ) {
        setTimeout(function(){

            //slider_text_position();

            $('.product-slides').slick({
                mobileFirst: true,
                respondTo: 'window',
                lazyLoad: 'progressive',
                autoplay: false,
                autoplaySpeed: 3000,
                arrows: true,
                dots: false,
                speed: 1000,
                infinite: true,
                adaptiveHeight: false,
                // prevArrow: "<img class='slick-arrow slick-prev prev' src='"+siteurl+"/wp-content/themes/mylanta-2022/_assets/img/slider-left-arrow.svg'>",
                // nextArrow: "<img class='slick-arrow slick-next next' src='"+siteurl+"/wp-content/themes/mylanta-2022/_assets/img/slider-right-arrow.svg'>",
                prevArrow: $('.prevArrow'),
                nextArrow: $('.nextArrow'),
                responsive: [{

                    breakpoint: 921,
                    settings: {
                      slidesToShow: 3,
                    }
              
                  }, {
              
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 2,
                    }
              
                  }, {
              
                    breakpoint: 320,
                    settings: {
                        slidesToShow: 1,
                    }
                  }]
            });

            $(".prev").hover(function(){
                $(".prev").attr("src", siteurl+"/wp-content/themes/mylanta-2022/_assets/img/slider-left-arrow-hover.svg");
                }, function(){
                $(".prev").attr("src", siteurl+"/wp-content/themes/mylanta-2022/_assets/img/slider-left-arrow.svg");
            });

            $(".next").hover(function(){
                $(".next").attr("src", siteurl+"/wp-content/themes/mylanta-2022/_assets/img/slider-right-arrow-hover.svg");
                }, function(){
                $(".next").attr("src", siteurl+"/wp-content/themes/mylanta-2022/_assets/img/slider-right-arrow.svg");
            });

            var p = $( ".prev" );
            var position = p.offset();
            //console.log(position);

            $(".prev").css('left', -Math.abs(position.left) );
            $(".next").css('right', -Math.abs(position.left) );

            if ( winWidth >= 768 ) {
                $('.product-slide-wrap').matchHeight();
            }

        }, 200);
    }

    add_target_blank_to_external_links_and_pdfs();

    // Top top button...
    $("#toTop").click(function () {
        $("html, body").animate({scrollTop: 0}, 500);
    });

    free_sample_cookie();

    $('.collapse').on('shown.bs.collapse', function(e) {
        var headerH = $('#header').outerHeight();
        var $card = $(this).closest('.accordion-item');
        var $open = $($(this).data('parent')).find('.collapse.show');
        
        var additionalOffset = headerH;
        if($card.prevAll().filter($open.closest('.accordion-item')).length !== 0)
        {
              additionalOffset =  $open.height();
        }
        if ($card.length) {
            $('html,body').animate({
            scrollTop: $card.offset().top - additionalOffset
            }, 500);
        }
    });

    // Copy Product ID to coupon form hidden field on click...
    $('body').on('click', '.get-coupon', function() {
        var mylanta_coupon_cookie = Cookies.get('__mylanta_coupon_dl');
        var userLang = $('html')[0].lang;
        var productID = $(this).attr("data-id");
        if (mylanta_coupon_cookie == null) {
            // Cookie NOT set...
            //var productID = $(this).attr("data-id");
            //console.log(productID);
            $('#gform_2 input[name="input_5"]').attr("value", productID);
        } else if (mylanta_coupon_cookie >= 5) {
            // Cookie Set, but at max downloads...
            if (userLang == 'es') {
                $('.download-wrapper').html('<p style="color:red" class="mb-0">Lo sentimos, ha alcanzado el máximo permitido de descargas de cupones para este año.</p>');
            } else {
                $('.download-wrapper').html('<p style="color:red" class="mb-0">Sorry, you have reached your maximum allowed coupon downloads for this year.</p>');
            }
            
        } else {
            // Cookie is set...
            $.ajax({
                url: ajaxurl,
                data: {
                    'action' : 'get_coupon_pdf',
                    'pID'    : productID
                },
                success:function(data) {
                    $('.download-wrapper').html(data);
                    // var mylanta_coupon_cookie = Cookies.get('__mylanta_coupon_dl');
                    // var domainURL = window.location.hostname;
                    // var mylantaCookieValue = parseInt(mylanta_coupon_cookie) + 1;
                    // Cookies.remove('__mylanta_coupon_dl', null, { path: '', domain: domainURL }) // removed!
                    // Cookies.set('__mylanta_coupon_dl', mylantaCookieValue, { expires: 365, secure: true, sameSite: 'strict', domain: domainURL });
                },
                error: function(errorThrown){
                    //window.alert(errorThrown);
                }
            });

        }
    });

    // Hide GForm confirmation message
    $('body').on('click', '#gform_confirmation_message_2 a', function() {
        $('#coupon-form').modal('toggle');
        $('#cForm').replaceWith('<div class="download-wrapper"></div>');
    });

    // Hide Modal on doanload button click
    $('body').on('click', '.cbtn', function(event) {
        $('#coupon-form').modal('toggle');
        $('#coupon-form .download-wrapper').empty();
        var mylanta_coupon_cookie = Cookies.get('__mylanta_coupon_dl');
        var domainURL = window.location.hostname;
        var mylantaCookieValue = parseInt(mylanta_coupon_cookie) + 1;
        Cookies.remove('__mylanta_coupon_dl', null, { path: '', domain: domainURL }) // removed!
        Cookies.set('__mylanta_coupon_dl', mylantaCookieValue, { expires: 365, secure: true, sameSite: 'strict', domain: domainURL });
    });

});

// Coupon Cookie Functions
$(document).on('gform_confirmation_loaded', function(event, formId){
    if(formId == 2) {
        var mylantaCookieValue = 1;
        var domainURL = window.location.hostname;
        Cookies.set('__mylanta_coupon_dl', mylantaCookieValue, { expires: 365, secure: true, sameSite: 'strict', domain: domainURL });
    } else {
       // do nothing
    }
});

// Once everything is loaded...
jQuery(window).on('load', function(){

    console.log( "Document loaded" );

    cat_image_padding();

    mega_menu();

    setTimeout(function(){
        var headerH = $('.header-inner').outerHeight();
        $('body').css('padding-top', headerH + 'px');
        $('#loader').fadeOut(300);
    }, 200);

});

// On Scroll
$(window).on('scroll', function(e) {

    updateHeader();

    setVar();

});

// On resize...
$(window).on('resize', function(e) {

    setTimeout(function(){
        var headerH = $('.header-inner').outerHeight();
        $('body').css('padding-top', headerH + 'px');
    }, 300);

    setVar();

    //slider_text_position();

    cat_image_padding();

    destini_margins();

});

$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 40
    }, 500);
});